module.exports = __webpack_public_path__ + "static/media/visa.a836d043.svg";